export default __webpack_public_path__ + "static/media/favicon.aa1543d1.ico";